import { render, staticRenderFns } from "./AtrativoCard.vue?vue&type=template&id=728f9b25&scoped=true"
import script from "./AtrativoCard.vue?vue&type=script&lang=js"
export * from "./AtrativoCard.vue?vue&type=script&lang=js"
import style0 from "./AtrativoCard.vue?vue&type=style&index=0&id=728f9b25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728f9b25",
  null
  
)

export default component.exports